import { call, put, takeEvery, all } from 'redux-saga/effects';
import { probabiliApi } from '../apiMiddleware/apiMiddleware';
import formationSchemas from '../common/formationSchemas/formationSchemas';
import * as types from '../constants';

function buildFormationSchema(lineUpPlayers, formationModule) {
  const formationObject = formationSchemas.find(schema => schema.formation === formationModule);
  const newFormationObject = JSON.parse(JSON.stringify(formationObject));
  let formationSchema = '';

  if (newFormationObject) {
    formationSchema = newFormationObject.formationSchema || '';
    let indice = 0;
    for (const [rowIndex, row] of formationSchema.entries()) {
      for (const [cellIndex, cell] of row.entries()) {
        if (cell.content) {
          const pObj = lineUpPlayers[indice];
          cell.content = pObj;
          row[cellIndex] = cell;
          indice += 1;
        }
      }
      formationSchema[rowIndex] = row;
    }
  }
  return formationSchema;
}

function iterateAttributes(attributes, obj) {
  for (let j = 0; j < attributes.length; j += 1) {
    const attribute = attributes.item(j);
    let attributeName = attribute.nodeName;
    if (attributeName === 'number') {
      attributeName = 'jerseyNumber';
    }
    obj[attributeName] = attribute.nodeValue;
  }
  return obj;
}

function iterateItem(item, obj) {
  if (item.hasChildNodes()) {
    let itemName = item.nodeName;
    if (itemName === 'calciatore') {
      itemName = 'playerName';
    }
    if (item.childNodes.length === 1 && item.childNodes[0].nodeType === 3) {
      obj[itemName] = item.childNodes[0].nodeValue;
    } else {
      const arr_New = [];
      item.childNodes.forEach((itemInner) => {
        let objNew = {};
        if (itemInner.attributes.length > 0) {
          objNew = iterateAttributes(itemInner.attributes, objNew);
        }
        objNew = iterateItem(itemInner, objNew);
        arr_New.push(objNew);
      });
      obj[itemName] = arr_New;
    }
  }
  return obj;
}

function stringToObj(value) {
  if (typeof value === 'string') {
    return { officialName: value };
  }
  return value;
}

function probabileFormazione(xml) {
  const pf = xml.getElementsByTagName('probabile_formazione');
  let obj = {};
  const pf_child = pf[0].childNodes;
  pf_child.forEach((item) => {
    obj = iterateItem(item, obj);
  });
  const modulo = obj.modulo.replace(/-/g, '');
  const ret_obj = {};
  ret_obj.formationModule = buildFormationSchema(obj.titolari, modulo);
  ret_obj.formationSchema = modulo;
  //ret_obj.mainPlayers = obj.titolari;
  ret_obj.benchPlayers = obj.panchina;
  ret_obj.unavailablePlayers = obj.indisponibili;
  ret_obj.suspendedPlayers = obj.squalificati ? obj.squalificati : [{ playerName: 'nessuno' }];
  ret_obj.warnedPlayers = obj.diffidati ? obj.diffidati : [{ playerName: 'nessuno' }];
  ret_obj.otherPlayers = obj.altri ? obj.altri : [{ playerName: 'nessuno' }];
  ret_obj.ballotPlayers = obj.ballottaggi ? obj.ballottaggi : [{ playerName: 'nessuno' }];
  ret_obj.otherPlayers = obj.altri ? obj.altri : [{ playerName: 'nessuno' }];
  ret_obj.official = stringToObj(obj.allenatore);
  ret_obj.teamName = obj.squadra;
  return ret_obj;
}

function* getProbabili(action) {
  const urlParams = {
    squadHome: action.squadHome,
    squadAway: action.squadAway,
    squadHomeId: action.squadHomeId,
    squadAwayId: action.squadAwayId,
    competitionId: action.competitionId,
  };
  try {
    yield all([
      put({
        type: types.GET_PROBABILI_HOME_REQUEST, squad: action.hometeam, competitionId: action.competitionId, widgetId: action.widgetId,
      }),
      put({
        type: types.GET_PROBABILI_AWAY_REQUEST, squad: action.awayteam, competitionId: action.competitionId, widgetId: action.widgetId,
      }),
      put({ type: types.GET_PROBABILI_SUCCESS, data: urlParams, widgetId: action.widgetId }),
    ]);
  } catch (error) {
    yield put({ type: types.GET_PROBABILI_ERROR, error });
  }
}

function* getProbabiliMethodeHome(action) {
  const urlParams = {
    squad: action.squad,
    competitionId: action.competitionId,
  };
  try {
    let data = yield call(probabiliApi, 'probabiliMethode', 'getProbabiliMethode', urlParams);
    data = data.replace(/(\r\n|\n|\r)/gm, '');
    const xmlDOM = new DOMParser().parseFromString(data, 'text/xml');
    const parsed = probabileFormazione(xmlDOM);
    yield put({ type: types.GET_PROBABILI_HOME_SUCCESS, data: parsed, widgetId: action.widgetId });
  } catch (error) {
    yield put({ type: types.GET_PROBABILI_HOME_ERROR, error });
  }
  return false;
}

function* getProbabiliMethodeAway(action) {
  const urlParams = {
    squad: action.squad,
    competitionId: action.competitionId,
  };
  try {
    let data = yield call(probabiliApi, 'probabiliMethode', 'getProbabiliMethode', urlParams);
    data = data.replace(/(\r\n|\n|\r)/gm, '');
    const xmlDOM = new DOMParser().parseFromString(data, 'text/xml');
    const parsed = probabileFormazione(xmlDOM);
    yield put({ type: types.GET_PROBABILI_AWAY_SUCCESS, data: parsed, widgetId: action.widgetId });
  } catch (error) {
    yield put({ type: types.GET_PROBABILI_AWAY_ERROR, error });
  }
  return false;
}

function* watchGetProbabili() {
  yield takeEvery(types.GET_PROBABILI_REQUEST, getProbabili);
}

function* watchGetProbabiliMethodeHome() {
  yield takeEvery(types.GET_PROBABILI_HOME_REQUEST, getProbabiliMethodeHome);
}

function* watchGetProbabiliMethodeAway() {
  yield takeEvery(types.GET_PROBABILI_AWAY_REQUEST, getProbabiliMethodeAway);
}

export default [
  watchGetProbabili,
  watchGetProbabiliMethodeHome,
  watchGetProbabiliMethodeAway,
];



// WEBPACK FOOTER //
// ./src/sagas/probabili.js